import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import { Link, useMatch } from "react-router";

import useDesktopLayout from "../../hooks/useDesktopLayout";

type Props = {
    label: string;
    icon: React.ReactElement;
    to: string;
    matchExact?: boolean;
};

export default function GaiaMenuItem({ label, icon, to, matchExact = false }: Props) {
    const { isSidebarCollapsed } = useDesktopLayout();

    // Match the path only, ignoring query parameters.
    const toPath = to.split("?")[0];
    const match = useMatch(matchExact ? toPath : `${toPath}/*`);

    return (
        <ListItem disablePadding>
            <ListItemButton component={Link} to={to} selected={match != null}>
                {icon && (
                    <ListItemIcon>
                        <Tooltip title={label} placement="right" disableHoverListener={isSidebarCollapsed === false}>
                            {icon}
                        </Tooltip>
                    </ListItemIcon>
                )}
                <ListItemText
                    primary={label}
                    slotProps={{
                        primary: { fontSize: "1rem", color: "text.primary", sx: { cursor: "pointer" } },
                    }}
                />
            </ListItemButton>
        </ListItem>
    );
}
